export const contactReassignTranslations = {
  title: `cng-contact_reassign-title`,
  titleWithParams: `cng-contact_reassign-title_with_params`,
  description: `cng-contact_reassign-description`,
  table: {
    header: {
      contactId: `cng-contact_reassign-table-header-contact_id`,
      name: `cng-contact_reassign-table-header-name`,
      email: `cng-contact_reassign-table-header-email`,
      hpRoles: `cng-contact_reassign-table-header-hp_roles`,
      view: `cng-contact_reassign-table-header-view`,
    },
  },
  button: {
    confirm: `cng-contact_reassign-button-confirm`,
    cancel: `cng-contact_reassign-button-cancel`,
  },
  tooltip: {
    view: `cng-contact_reassign-tooltip-view`,
  },
  input: {
    search: `cng-contact_reassign-input-search`,
  },
  selectContact: 'contact-reassignment-row-select',
  preview: 'contact-reassignment-row-preview',
}
